export enum RestResponseStatus {
    SUCCESS = '1',
    FAILURE = '0',
}
